module.exports = __webpack_public_path__ + "58aa9378523399d5c151c6f6fe1ed685.png";